const NOVO = "novo";
const CANCELADO = "cancelado";
const FINALIZADO = "finalizado";
const TRANSFERIDO = "transferido";
const EM_ANDAMENTO = "em andamento";
const APLICADO = "aplicado";
const A_APLICAR = "a aplicar";

class Status {
  static get NOVO() {
    return NOVO;
  }
  static get EM_ANDAMENTO() {
    return EM_ANDAMENTO;
  }
  static get FINALIZADO() {
    return FINALIZADO;
  }
  static get CANCELADO() {
    return CANCELADO;
  }
  static get TRANSFERIDO() {
    return TRANSFERIDO;
  }
  static get A_APLICAR() {
    return A_APLICAR;
  }
  static get APLICADO() {
    return APLICADO;
  }

  static all() {
    return [
      NOVO,
      EM_ANDAMENTO,
      FINALIZADO,
      CANCELADO,
      TRANSFERIDO,
      A_APLICAR,
      APLICADO,
    ];
  }
}

const CIRURGIA = "cirurgia";
const CLINICO = "clínico";
const DAY_CARE = "day care";
const EM_ESPERA = "em espera";
const ESTETICO = "estético";
const EXTERNO = "externo";
const GERAL = "geral";
const HOSPEDAGEM = "hospedagem";
const INTERNACAO = "internação";
const PESAGEM = "pesagem";
const RECEITUARIO = "receituário";
const VACINA = "vacina";
const VERMIFUGO = "vermífugo";

const tiposServicos = [
  CIRURGIA,
  CLINICO,
  DAY_CARE,
  ESTETICO,
  EXTERNO,
  GERAL,
];

const tipos = {
  [CIRURGIA]: { key: "CIRURGIA", color: "#FC07CA", icon: "heart-pulse" },
  [CLINICO]: { key: "CLINICO", color: "#F5AF59", icon: "medical-bag" },
  [DAY_CARE]: { key: "DAY_CARE", color: "#7FFF00", icon: "hand-heart" },
  [EM_ESPERA]: { key: "EM_ESPERA", color: "#FF1053", icon: "clock-outline" },
  [ESTETICO]: { key: "ESTETICO", color: "#4BD98A", icon: "auto-fix" },
  [EXTERNO]: { key: "EXTERNO", color: "#9D1EDF", icon: "ambulance" },
  [GERAL]: { key: "GERAL", color: "#7DCAF0", icon: "earth" },
  [HOSPEDAGEM]: { key: "HOSPEDAGEM", color: "#9C735C", icon: "home" },
  [INTERNACAO]: {
    key: "INTERNACAO",
    color: "#E05207",
    icon: "hospital-building",
  },
  [PESAGEM]: { key: "PESAGEM", color: "#0DAAC1", icon: "scale-balance" },
  [RECEITUARIO]: {
    key: "RECEITUARIO",
    color: "#AF5CC1",
    icon: "notebook-multiple",
  },
  [VACINA]: { key: "VACINA", color: "#EEEE3B", icon: "eyedropper" },
  [VERMIFUGO]: { key: "VERMIFUGO", color: "#4B8F8C", icon: "pill" },
};

const controleAcesso = async function (data) {
  const isFinalizado = [FINALIZADO, APLICADO].includes(data.statusOld);

  if (!isFinalizado && data.statusOld === data.statusNew) {
    return new Promise((resolve) => resolve());
  }

  const senhas = await Siggma.getFiliaisPreferencias([
    "senhaPetshopEditarFinalizado",
    "senhaPetshopCancelar",
    "senhaPetshopExcluir",
  ]).then(({ data }) => data).catch(() => {});

  return new Promise((resolve, reject) => {
    let params = null;

    if (isFinalizado && senhas?.senhaPetshopEditarFinalizado) {
      params = {
        type: "senha_petshop_editar_finalizado",
        msg: `Informe a senha para editar atendimento <b>${data.statusOld}</b>`,
      };
    }

    if (data.statusNew === CANCELADO && senhas?.senhaPetshopCancelar) {
      params = {
        type: "senha_petshop_cancelar",
        msg: "Informe a senha para <b>cancelar</b> o atendimento",
      };
    }

    if (data.statusNew === "excluido" && senhas?.senhaPetshopExcluir) {
      params = {
        type: "senha_petshop_excluir",
        msg: "Informe a senha para <b>excluir</b> o atendimento",
      };
    }

    if (!params) {
      resolve();
      return;
    }

    params.liberar = resolve;
    params.bloquear = reject;
    Siggma.controleAcesso(params, data.hdl);
  });
};

const pacoteFinalizado = (data, delay = 0) => {
  !!data?.id && data?.restantes === 0 && setTimeout(() => {
    globalThis.Yanda.confirm({
      msg:
        "Pacote finalizado!<br>Deseja lançar outro pacote para o mesmo animal?",
      actionTrue() {
        globalThis.Yanda.newApl(144, { pacoteRefId: data.id, renovado: true });
      },
    });
  }, delay);
};

export default {
  tipos,
  tiposServicos,
  tiposKeys: {
    CIRURGIA,
    CLINICO,
    DAY_CARE,
    EM_ESPERA,
    ESTETICO,
    EXTERNO,
    GERAL,
    HOSPEDAGEM,
    INTERNACAO,
    PESAGEM,
    RECEITUARIO,
    VACINA,
    VERMIFUGO,
  },

  controleAcesso,
  pacoteFinalizado,
  status: Status,
  tiposHistoricos() {
    const Siggma = globalThis.Siggma;
    const tps = [];
    for (const name in tipos) {
      const obj = this.tipos[name];
      const css = {
        alignItems: "center",
        background: obj.color,
        border: "1px solid",
        borderColor: Siggma.Color(obj.color).darken(0.3).string(),
        borderRadius: "50%",
        color: Siggma.getContrastYiq(obj.color),
        display: "inline-flex",
        height: "28px",
        justifyContent: "center",
        margin: "0 5px",
        padding: "0 0",
        width: "28px",
      };

      ![EM_ESPERA].includes(name) && tps.push({ name, css, icon: obj.icon });
    }
    return tps;
  },
};
